<template>
  <span class="+type-body-one +text-crop-none +font-circular-bold">
    {{ rate }}% {{ oaDataType }}
  </span>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    data: {
      type: Array
    },
    oaDataType: {
      type: String,
      default: 'APR'
    }
  },
  computed: {
    /**
     * Rate value from OA service.
     * @returns {string|response|{}|*|Object|boolean}
     */
    rate() {
      return (
        (typeof this.data[this.data.length - 1] !== 'undefined' &&
          Number(this.data[this.data.length - 1].ratevalue).toFixed(2)) ||
        0
      )
    }
  }
}
</script>
